/* eslint-disable */
import Vue from 'vue'

import store from '@/store/index'
import cityMap from '@/plugins/city-map/Index'
import i18n from '@/i18n'
import Vuetify from '@/plugins/Vuetify'
import router from '@/router/index'

import WidgetPlugin from '@/plugins/Widget'

require('@/services/SessionLink')

class Widget {
  widget:any
  parentLocation:any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
  }

  state () {
    const storage:any = store.state.storage
    return storage.state
  }

  // CONFIGS
  locale () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 8)
    return config ? config.value : 'es'
  }

  rocioRecommendation () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 20)
    return config ? (config.value === 'true') : false
  }

  enableChatBot () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 37)
    return config ? (config.value === 'true') : true
  }

  contactCenter () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 5)
    return config ? (config.value === 'true') : false
  }

  calendaryModule () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 2)
    return config ? (config.value === 'true') : false
  }

  dynamics365 () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 4)
    return config ? (config.value === 'true') : false
  }

  salesForce () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 28)
    return config ? (config.value === 'true') : false
  }

  zoho () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 36)
    return config ? (config.value === 'true') : false
  }

  validationEmail () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 30)
    return config ? (config.value === 'true') : false
  }

  analitycs () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 9)
    return config ? (config.value === 'true') : false
  }

  directCallModule () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 6)
    return config ? (config.value === 'true') : true
  }

  allowUserShareFiles () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 18)
    return config ? (config.value === 'true') : true
  }

  allowChatForUser () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 21)
    return config ? (config.value === 'true') : true
  }

  allowEmojisForWidgetChat () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 24)
    return config ? (config.value === 'true') : false
  }

  allowWidgetScreenSharing () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 25)
    return config ? (config.value === 'true') : true
  }

  enableWidgeBlur () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 23)
    return config ? (config.value === 'true') : true
  }

  videoProcessorConfig () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 43)
    const isActive = config ? (config.value === 'true') : false

    const defaultData:object = {
      nsfw: {
        autoEnable: false,
        threshold: 0.75,
        model: 'InceptionV3',
        categories: ['Porn', 'Hentai'],
        sampleIntervalMs: 1500,
        autoBlur: false,
        windowSize: 5,
        minExplicitInWindow: 3,
        cooldownMs: 30000
      },
      backgrounds: {
        enabled: false
      }
    }

    return {
      isActive,
      data: isActive && config && config.data ? JSON.parse(config.data) : defaultData
    }
  }

  streamingPlayer () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 34)
    const isActive = config ? (config.value === 'true') : false

    const defaultData:any = null

    return {
      isActive,
      data: config && config.data ? JSON.parse(config.data) : defaultData
    }
  }

  totemMode () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 31)
    const isActive = config ? (config.value === 'true') : false

    const defaultData:object = {
      HTTP: {
        authentication: {
          headers: {},
          route: null,
          method: 'post',
          body: {}
        },
        totemStatus: {
          headers: {},
          route: null,
          method: 'put'
        }
      },
      content: {
        banner_src: null,
        active_advertisement: false,
        brand_src: 'https://widget.ocularsolution.com/service/ocular/images/logoocular.jpg',
        bg_color: 'white',
        text_color: '#222',
        title: i18n.t('info.title'),
        description: i18n.t('info.subtitle')
      },
      on_hold_content: {
        banner_src: null,
        active_advertisement: false,
        brand_src: 'https://widget.ocularsolution.com/service/ocular/images/logoocular.jpg',
        bg_color: 'white',
        text_color: '#222',
        title: 'En un momento lo atenderemos',
        description: 'Por favor espere un momento, nuestro ejecutivo lo atenderá en breves segundos.'
      }
    }

    return {
      isActive,
      data: config && config.data ? JSON.parse(config.data) : defaultData
    }
  }

  googleAnalitycs () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 32)
    const isActive = config ? (config.value === 'true') : false

    return {
      isActive,
      data: config && config.data ? JSON.parse(config.data) : null,
      dataLayerConfig: config && config.googleAnalyticsConfig ? config.googleAnalyticsConfig : null
    }
  }

  detectCammerAvailability () {
    const config:any = store.state.widget.data.configs.find((config:any) => config.type === 33)
    const isActive = config ? (config.value === 'true') : false

    const defaultData:object = {
      attentionTypes: 'false',
      permissions: 'false',
      lobby: 'false'
    }

    return {
      isActive,
      data: isActive && config && config.data ? JSON.parse(config.data) : defaultData
    }
  }

  customerVerificationWebKey () {
    const config: any = store.state.widget.data.configs.find((config:any) => config.type === 41)
    const isActive = config ? (config.value === 'true') : false

    const defaultData = null

    return {
      isActive,
      data: isActive && config && config.data ? JSON.parse(config.data) : defaultData
    }
  }

  // CONFIGS

  // ATTRIBUTES
  widgetContent () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 2)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData: object = {
      lobby: {
        ot_error: i18n.t('detail.otError'),
        no_cammers_connected: i18n.t('detail.noCammersConnected'),
        scheduled_organization: {
          title: i18n.t('detail.scheduled_organization.title'),
          description: i18n.t('detail.scheduled_organization.description'),
          title_schedule_attention: i18n.t('detail.scheduled_organization.titleScheduleAttention'),
          no_schedule: i18n.t('detail.scheduled_organization.noSchedule'),
        },
        contact_request_form: {
          title: i18n.t('lobby.contactRequestForm.title'),
        }
      }
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : null,
      defaultData
    }
  }

  primaryColor () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 14)
    return attribute ? attribute.value : '#204DEF'
  }

  // TEXT CONFIGS
  termsConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 42)
    return attribute ? JSON.parse(attribute.value) : false
  }

  attentionTypesConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 43)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('attentionTypes.title'),
      description: i18n.t('attentionTypes.select'),
      options: [
        {
          id: 1,
          to: '/permissions',
          icon: 'video-outline',
          title: i18n.t('attentionTypes.now.label'),
          description: i18n.t('attentionTypes.now.description'),
          channels: [ 'video' ]
        },
        {
          id: 2,
          to: '/calendar',
          icon: 'calendar',
          title: i18n.t('attentionTypes.scheduled.label'),
          description: i18n.t('attentionTypes.scheduled.description'),
          channels: [ 'video' ]
        }
      ],
      information: null
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  systemBarConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 45)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: 'Atención',
      maximize: true,
      minimize: true,
      close: true,
      more: {
        active: true,
        options: {
          align: true,
          close: true
        }
      }
    }

    return {
      isActive,
      data: isActive && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  permissionsConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 46)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('permissions.title2')
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  goodByeConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 47)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('thankYouPage.goodBye.title'),
      description: i18n.t('thankYouPage.goodBye.description')
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  btnPrimaryConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 48)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      btn: 'primary',
      text: '#fff'
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  emptySessionConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 49)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('session.empty.title'),
      description: i18n.t('session.empty.description')
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  emptyMessageConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 50)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('chat.messages.empty.title'),
      description: i18n.t('chat.messages.empty.description')
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  calificationConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 51)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData: object = {
      viewTitle: i18n.t('calification.title'),
      subtitle: '',
      label: i18n.t('calification.observationLabel'),
      placeholder: i18n.t('calification.observationPlaceHolder'),
      btnText: i18n.t('calification.rate'),
      style: 'star',
      settings: {
        timeToRate: null,
        btnWithoutRate: false,
        form: {
          isActive: false
        }
      },
      colorPalette: {
        isActive: false,
        initColor: '#FF0000',
        endColor: '#23FF00'
      },
      requireRating: true,
      btnWithoutRate: i18n.t('calification.withoutRate'),
      instructionText: '',
      initialRating: WidgetPlugin.getOrganizationSettings().rating.limit
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : null,
      defaultData
    }
  }

  calendarConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 52)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('calendar.title'),
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  schedulingConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 53)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('thankYouPage.scheduling.title')
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  categoriesConfig () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 54)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('categories.select')
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  configInitCall () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 57)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      fullScreen: {
        desktop: false,
        mobile: false
      },
      publisherVideo: {
        position: 'bottom-right',
        width: 80,
        height: 100,
        rotation: 0
      },
      publisherAudio: {
        noiseSuppression: true
      },
      requestAccessToDevices: true
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  callingMessage () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 1)

    const isActive = attribute ? (attribute.value === 'true') : false

    const defaultData:object = {
      title: i18n.t('calling.message'),
      animation: true,
      cancelable: false
    }

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  // TODO: dejar de usar, usar para posterior funcionalidad
  termsAndConditionsLink () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 27)
    return widgetAttr ? widgetAttr.value : 'https://terms.ocularsolution.com'
  }

  // TODO: dejar de usar, usar para posterior funcionalidad
  termsAndConditionsRequired () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 29)
    return widgetAttr ? (widgetAttr.value === 'true') : false
  }

  termsAndConditionsConfig () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr: any) => attr.type === 42 && attr.value === 'true')

    const config = JSON.parse(widgetAttr?.data ?? '{}')
    const link   = config?.link ?? 'https://terms.ocularsolution.com'

    const show = config?.show ?? true
    const required = config?.required ?? false
    const label = config?.label ?? `${i18n.t(`t&c.${required ? 'accept' : 'continue'}`)} <a href="${link}" target="_blank">${i18n.t('t&c.termAndConditions')}</a> ${!required ? i18n.t('t&c.begin') : ''}`

    return { show, required, label }
  }

  formIsMain () {
    const attribute:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 56)

    const isActive = attribute ? (attribute.value === 'true') : true

    const defaultData:object = {}

    return {
      isActive,
      data: isActive && attribute && attribute.data ? JSON.parse(attribute.data) : defaultData
    }
  }

  questionViewTitle () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 33)
    return widgetAttr ? widgetAttr.value : i18n.t('question.title')
  }

  requireQuestion () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 34)
    return widgetAttr ? (widgetAttr.value === 'true') : false
  }

  questionViewDescription () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 35)
    return widgetAttr ? widgetAttr.value : i18n.t('question.description')
  }

  doNotAnswerQuestion  () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 36)
    return widgetAttr ? (widgetAttr.value === 'true') : true
  }

  // TODO: dejar de usar, usar para posterior funcionalidad
  initialRating () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 28)
    return widgetAttr ? Number(widgetAttr.value) : WidgetPlugin.getOrganizationSettings().rating.limit
  }

  // TODO: dejar de usar, usar para posterior funcionalidad
  requireRating () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 30)
    return widgetAttr ? (widgetAttr.value === 'true') : true
  }

  // TODO: dejar de usar, usar para posterior funcionalidad
  typeRating () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 40)
    return widgetAttr ? widgetAttr.value : 'star'
  }

  hideOnFinish () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 31)
    return widgetAttr ? (widgetAttr.value === 'true') : false
  }

  categoriesViewTitle () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 25)
    return widgetAttr ? widgetAttr.value : i18n.t('categories.title')
  }

  parentToggle () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 26)
    return widgetAttr ? (widgetAttr.value === 'true') : false
  }

  smartMode () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 6)
    return widgetAttr ? (widgetAttr.value === 'Inteligente') : false
  }

  darkMode () {
    const widgetAttr:any = store.state.widget.data.attributes.find((attr:any) => attr.type === 16)
    return widgetAttr ? (widgetAttr.value === 'true') : false
  }
  // ATTRIBUTES

  setLocale (lang = null) {
    const storage:any = store.state.storage

    if (storage.widget.lang) {
      lang = storage.widget.lang
    }

    const locale = lang ? lang : this.locale()
    i18n.locale = locale
    store.state.locale = locale
  }

  setPrimaryColor () {
    Vuetify.framework.theme.themes.light.primary = this.primaryColor()
  }

  setSmallVersion() {
    const primaryColor = this.primaryColor()

    const config = {
      height: 200,
      primaryColor
    }

    Vue.prototype.$widget.setDefaultConfig(config)
  }

  mount () {
    this.setLocale()
    this.setPrimaryColor()
  }

  getWidgetSuccess (widget:any, storage:any) {
    store.state.storage = storage
    store.state.widget.data = widget
    Vue.prototype.$widget.setParentLocation()
    this.mount()
    store.state.widget.loading = false
  }

  getWidgetError (error:any) {
    store.state.widget.error = error
    store.state.widget.loading = false
  }

  getWidget () {
    store.state.widget.loading = true

    const params = new URLSearchParams(location.search)

    if (!params.get('origin')) {
      setTimeout(() => {
        store.state.widget.loading = false
      }, 1000)
      return false
    }

    store.state.widget.error = null

    const data:any = {
      route: 'ocular/widget/init-ocular',
      method: 'GET',
      params: {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      },
      successHandler: 'widget.getWidgetSuccess',
      errorHandler: 'widget.getWidgetError'
    }

    const country = cityMap.country
    if (country) {
      data.params.iso = country.iso
    }

    try {
      const urlOrigin = () => {
        const parentLocation = <any> {
          hostname: params.get('hostname'),
          pathname: params.get('pathname'),
          search: params.get('search'),
          hash: params.get('hash')
        }

        const hostname = !parentLocation.hostname.indexOf('www') ? parentLocation.hostname.substring(4) : parentLocation.hostname
        let urlOrigin = `${hostname}${parentLocation.pathname}`
        urlOrigin = Vue.prototype.$widget.endsWith(urlOrigin, '/') ? urlOrigin : `${urlOrigin}/`
        urlOrigin += `${parentLocation.search}${parentLocation.hash}`

        return urlOrigin
      }

      data.params.url = urlOrigin()
    } catch (error) {
      console.log('getWidget ERROR', error)
    }

    window.parent.postMessage(`organization.getWidget(${JSON.stringify(data)})`, '*')
  }

  mountSessionLink (organizationName:string, token:string) {
    const routerData:any = router

    if (routerData.history.current.name === 'organizationSessionLink' || (!organizationName && !token)) {
      return false
    }

    routerData.replace({ path: `${organizationName}/session/${token}`, query: { widgetMode: 'true' } })
  }
}
const widget = <any> new Widget();
Vue.prototype.$organization = widget;
export default widget;

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    widget[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
